import type { PluginName } from '../types';

const PLUGIN_MAP: Record<PluginName, () => Promise<unknown>> = {
  align: () => import('froala-editor/js/plugins/align.min'),
  bold: () => Promise.resolve(),
  colors: () => import('froala-editor/js/plugins/colors.min'),
  emoticons: () => import('froala-editor/js/plugins/emoticons.min'),
  entities: () => import('froala-editor/js/plugins/entities.min'),
  font_size: () => import('froala-editor/js/plugins/font_size.min'),
  help: () => import('froala-editor/js/plugins/help.min'),
  image: () => import('froala-editor/js/plugins/image.min'),
  inline_class: () => import('froala-editor/js/plugins/inline_class.min'),
  line_breaker: () => import('froala-editor/js/plugins/line_breaker.min'),
  line_height: () => import('froala-editor/js/plugins/line_height.min'),
  link: () => import('froala-editor/js/plugins/link.min'),
  lists: () => import('froala-editor/js/plugins/lists.min'),
  paragraph_format: () => import('froala-editor/js/plugins/paragraph_format.min'),
  quote: () => import('froala-editor/js/plugins/quote.min'),
  special_characters: () => import('froala-editor/js/plugins/special_characters.min'),
  table: () => import('froala-editor/js/plugins/table.min'),
  url: () => import('froala-editor/js/plugins/url.min'),
  word_paste: () => import('froala-editor/js/plugins/word_paste.min'),
};

export async function loadPlugins(plugins: PluginName[]): Promise<void> {
  if (!plugins || plugins.length === 0) {
    return;
  }

  const importPromises = plugins
    .filter((plugin) => PLUGIN_MAP[plugin])
    .map((plugin) => PLUGIN_MAP[plugin]());

  try {
    await Promise.all(importPromises);
  } catch (error) {
    //biome-ignore lint/suspicious/noConsole: need to log this error
    console.error('Failed to load Froala plugins:', error);
  }
}

export const DEFAULT_PLUGINS: PluginName[] = [
  'table',
  'align',
  'bold',
  'link',
  'lists',
  'quote',
  'paragraph_format',
];

export const EXTENDED_PLUGINS: PluginName[] = [
  ...DEFAULT_PLUGINS,
  'colors',
  'font_size',
  'line_height',
  'inline_class',
  'image',
  'special_characters',
  'word_paste',
];

export const FULL_PLUGINS: PluginName[] = [
  ...EXTENDED_PLUGINS,
  'emoticons',
  'entities',
  'help',
  'line_breaker',
  'url',
];
